export var SelectionMode;
(function (SelectionMode) {
    SelectionMode["FROM"] = "From";
    SelectionMode["TO"] = "To";
})(SelectionMode || (SelectionMode = {}));
export var TradeMode;
(function (TradeMode) {
    TradeMode["BUY"] = "Buy";
    TradeMode["SELL"] = "Sell";
    TradeMode["SWAP"] = "Swap";
})(TradeMode || (TradeMode = {}));
